import { render, staticRenderFns } from "./NoRecordFound.vue?vue&type=template&id=587d8731"
import script from "./NoRecordFound.vue?vue&type=script&lang=js"
export * from "./NoRecordFound.vue?vue&type=script&lang=js"
import style0 from "./NoRecordFound.vue?vue&type=style&index=0&id=587d8731&prod&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports